import { default as mieterhymzzoSpGGMeta } from "/vercel/path0/pages/AGB/mieter.vue?macro=true";
import { default as vermieterBDgPiDZBSoMeta } from "/vercel/path0/pages/AGB/vermieter.vue?macro=true";
import { default as _91slug_93ONTRCFwGiTMeta } from "/vercel/path0/pages/auflieger/[slug].vue?macro=true";
import { default as invitation419vjd0S8DMeta } from "/vercel/path0/pages/auth/invitation.vue?macro=true";
import { default as recoverylm8wIpdohQMeta } from "/vercel/path0/pages/auth/password/recovery.vue?macro=true";
import { default as resetYcjzWS9Un8Meta } from "/vercel/path0/pages/auth/password/reset.vue?macro=true";
import { default as welcomeqjyldHOkHLMeta } from "/vercel/path0/pages/auth/welcome.vue?macro=true";
import { default as _91slug_93Po03rnzIFtMeta } from "/vercel/path0/pages/blog/[slug].vue?macro=true";
import { default as indexmfxAx2eWMBMeta } from "/vercel/path0/pages/blog/index.vue?macro=true";
import { default as _91id_93WfVkVMnnRsMeta } from "/vercel/path0/pages/confirm-offer/[id].vue?macro=true";
import { default as v1Rj8A6zB9OTMeta } from "/vercel/path0/pages/confirm-offer/v1.vue?macro=true";
import { default as v251I2Wr3G6HMeta } from "/vercel/path0/pages/confirm-offer/v2.vue?macro=true";
import { default as datenschutzKnOBKfKJS8Meta } from "/vercel/path0/pages/datenschutz.vue?macro=true";
import { default as impressumTRtm3XZBRUMeta } from "/vercel/path0/pages/impressum.vue?macro=true";
import { default as indexe9Brt5DfdhMeta } from "/vercel/path0/pages/index.vue?macro=true";
import { default as kontaktgUfu4Sf1oqMeta } from "/vercel/path0/pages/kontakt.vue?macro=true";
import { default as _91slug_93M4JnKScG8GMeta } from "/vercel/path0/pages/lkw/[slug].vue?macro=true";
import { default as logint0AWlhQgM0Meta } from "/vercel/path0/pages/login.vue?macro=true";
import { default as _91id_932gRoRqXXC0Meta } from "/vercel/path0/pages/offers/[id].vue?macro=true";
import { default as index7pp5WpoXdvMeta } from "/vercel/path0/pages/offers/index.vue?macro=true";
import { default as become_45supplierCh9CUGI5HRMeta } from "/vercel/path0/pages/plattform/become-supplier.vue?macro=true";
import { default as indexwfK9VxuJPkMeta } from "/vercel/path0/pages/plattform/marketplace/[id]/index.vue?macro=true";
import { default as indexvFH8izixdsMeta } from "/vercel/path0/pages/plattform/marketplace/[id]/offer/index.vue?macro=true";
import { default as indexGU4WFdKyhrMeta } from "/vercel/path0/pages/plattform/marketplace/index.vue?macro=true";
import { default as indexCkvNk9pIkaMeta } from "/vercel/path0/pages/plattform/my-requests/index.vue?macro=true";
import { default as index819NnUKx0GMeta } from "/vercel/path0/pages/plattform/registrieren/index.vue?macro=true";
import { default as index4W4znDFt6wMeta } from "/vercel/path0/pages/plattform/requests/index.vue?macro=true";
import { default as indexi4VS1Se2dMMeta } from "/vercel/path0/pages/plattform/templates/[id]/index.vue?macro=true";
import { default as indexcXtClbWDZCMeta } from "/vercel/path0/pages/plattform/templates/index.vue?macro=true";
import { default as indexgQNLTee9ZhMeta } from "/vercel/path0/pages/plattform/templates/new/index.vue?macro=true";
import { default as plattformQTPMHPN2mwMeta } from "/vercel/path0/pages/plattform.vue?macro=true";
import { default as indexAwL9z7MlvzMeta } from "/vercel/path0/pages/request-quote/index.vue?macro=true";
import { default as _91slug_93ebcEipPCqyMeta } from "/vercel/path0/pages/sattelzugmaschinen/[slug].vue?macro=true";
import { default as signupY93ILdpGpbMeta } from "/vercel/path0/pages/signup.vue?macro=true";
import { default as ueber_45unsToge4ZIkjdMeta } from "/vercel/path0/pages/ueber-uns.vue?macro=true";
import { default as vermietentAEmrQOti3Meta } from "/vercel/path0/pages/vermieten.vue?macro=true";
import { default as component_45stub5X4Ei38PMgMeta } from "/vercel/path0/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stub5X4Ei38PMg } from "/vercel/path0/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "AGB-mieter",
    path: "/AGB/mieter",
    component: () => import("/vercel/path0/pages/AGB/mieter.vue").then(m => m.default || m)
  },
  {
    name: "AGB-vermieter",
    path: "/AGB/vermieter",
    component: () => import("/vercel/path0/pages/AGB/vermieter.vue").then(m => m.default || m)
  },
  {
    name: "auflieger-slug",
    path: "/auflieger/:slug()",
    component: () => import("/vercel/path0/pages/auflieger/[slug].vue").then(m => m.default || m)
  },
  {
    name: "auth-invitation",
    path: "/auth/invitation",
    component: () => import("/vercel/path0/pages/auth/invitation.vue").then(m => m.default || m)
  },
  {
    name: "auth-password-recovery",
    path: "/auth/password/recovery",
    component: () => import("/vercel/path0/pages/auth/password/recovery.vue").then(m => m.default || m)
  },
  {
    name: "auth-password-reset",
    path: "/auth/password/reset",
    component: () => import("/vercel/path0/pages/auth/password/reset.vue").then(m => m.default || m)
  },
  {
    name: "auth-welcome",
    path: "/auth/welcome",
    component: () => import("/vercel/path0/pages/auth/welcome.vue").then(m => m.default || m)
  },
  {
    name: "blog-slug",
    path: "/blog/:slug()",
    component: () => import("/vercel/path0/pages/blog/[slug].vue").then(m => m.default || m)
  },
  {
    name: "blog",
    path: "/blog",
    component: () => import("/vercel/path0/pages/blog/index.vue").then(m => m.default || m)
  },
  {
    name: "confirm-offer-id",
    path: "/confirm-offer/:id()",
    component: () => import("/vercel/path0/pages/confirm-offer/[id].vue").then(m => m.default || m)
  },
  {
    name: "confirm-offer-v1",
    path: "/confirm-offer/v1",
    component: () => import("/vercel/path0/pages/confirm-offer/v1.vue").then(m => m.default || m)
  },
  {
    name: "confirm-offer-v2",
    path: "/confirm-offer/v2",
    component: () => import("/vercel/path0/pages/confirm-offer/v2.vue").then(m => m.default || m)
  },
  {
    name: "datenschutz",
    path: "/datenschutz",
    component: () => import("/vercel/path0/pages/datenschutz.vue").then(m => m.default || m)
  },
  {
    name: "impressum",
    path: "/impressum",
    component: () => import("/vercel/path0/pages/impressum.vue").then(m => m.default || m)
  },
  {
    name: "index",
    path: "/",
    component: () => import("/vercel/path0/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "kontakt",
    path: "/kontakt",
    component: () => import("/vercel/path0/pages/kontakt.vue").then(m => m.default || m)
  },
  {
    name: "lkw-slug",
    path: "/lkw/:slug()",
    component: () => import("/vercel/path0/pages/lkw/[slug].vue").then(m => m.default || m)
  },
  {
    name: "login",
    path: "/login",
    component: () => import("/vercel/path0/pages/login.vue").then(m => m.default || m)
  },
  {
    name: "offers-id",
    path: "/offers/:id()",
    component: () => import("/vercel/path0/pages/offers/[id].vue").then(m => m.default || m)
  },
  {
    name: "offers",
    path: "/offers",
    meta: index7pp5WpoXdvMeta || {},
    component: () => import("/vercel/path0/pages/offers/index.vue").then(m => m.default || m)
  },
  {
    name: "plattform",
    path: "/plattform",
    meta: plattformQTPMHPN2mwMeta || {},
    component: () => import("/vercel/path0/pages/plattform.vue").then(m => m.default || m),
    children: [
  {
    name: "plattform-become-supplier",
    path: "become-supplier",
    component: () => import("/vercel/path0/pages/plattform/become-supplier.vue").then(m => m.default || m)
  },
  {
    name: "plattform-marketplace-id",
    path: "marketplace/:id()",
    component: () => import("/vercel/path0/pages/plattform/marketplace/[id]/index.vue").then(m => m.default || m)
  },
  {
    name: "plattform-marketplace-id-offer",
    path: "marketplace/:id()/offer",
    component: () => import("/vercel/path0/pages/plattform/marketplace/[id]/offer/index.vue").then(m => m.default || m)
  },
  {
    name: "plattform-marketplace",
    path: "marketplace",
    component: () => import("/vercel/path0/pages/plattform/marketplace/index.vue").then(m => m.default || m)
  },
  {
    name: "plattform-my-requests",
    path: "my-requests",
    component: () => import("/vercel/path0/pages/plattform/my-requests/index.vue").then(m => m.default || m)
  },
  {
    name: "plattform-registrieren",
    path: "registrieren",
    component: () => import("/vercel/path0/pages/plattform/registrieren/index.vue").then(m => m.default || m)
  },
  {
    name: "plattform-requests",
    path: "requests",
    component: () => import("/vercel/path0/pages/plattform/requests/index.vue").then(m => m.default || m)
  },
  {
    name: "plattform-templates-id",
    path: "templates/:id()",
    component: () => import("/vercel/path0/pages/plattform/templates/[id]/index.vue").then(m => m.default || m)
  },
  {
    name: "plattform-templates",
    path: "templates",
    component: () => import("/vercel/path0/pages/plattform/templates/index.vue").then(m => m.default || m)
  },
  {
    name: "plattform-templates-new",
    path: "templates/new",
    component: () => import("/vercel/path0/pages/plattform/templates/new/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "request-quote",
    path: "/request-quote",
    component: () => import("/vercel/path0/pages/request-quote/index.vue").then(m => m.default || m)
  },
  {
    name: "sattelzugmaschinen-slug",
    path: "/sattelzugmaschinen/:slug()",
    component: () => import("/vercel/path0/pages/sattelzugmaschinen/[slug].vue").then(m => m.default || m)
  },
  {
    name: "signup",
    path: "/signup",
    component: () => import("/vercel/path0/pages/signup.vue").then(m => m.default || m)
  },
  {
    name: "ueber-uns",
    path: "/ueber-uns",
    component: () => import("/vercel/path0/pages/ueber-uns.vue").then(m => m.default || m)
  },
  {
    name: "vermieten",
    path: "/vermieten",
    component: () => import("/vercel/path0/pages/vermieten.vue").then(m => m.default || m)
  },
  {
    name: component_45stub5X4Ei38PMgMeta?.name,
    path: "/elektro/:pathMatch(.*)",
    component: component_45stub5X4Ei38PMg
  }
]